<!--
 * @Author: van
 * @Date: 2021-09-28 15:50:33
 * @LastEditors: van
 * @LastEditTime: 2021-09-29 09:12:08
-->
<template>
  <el-dialog class="addstore"
             :visible.sync="addVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             title="新增店铺并授权"
             :modal-append-to-body="false"
             append-to-body>
    <div class="container"
         v-loading="loading">
      <el-form ref="addForm"
               :model="addForm"
               label-width="100px" @keydown.enter.native.prevent>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="店铺名称"
                          :rules="[{ required: true, message: '请输入店铺名称' }]"
                          prop="name"
                          size="small">
              <el-input clearable
                        placeholder="请输入店铺名称"
                        maxlength="100"
                        size="small"
                        v-model="addForm.name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺简称"
                          size="small">
              <el-input clearable
                        placeholder="请输入店铺简称"
                        maxlength="100"
                        size="small"
                        v-model="addForm.shop_abbr">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属平台"
                          :rules="[{ required: true, message: '请选择所属平台' }]"
                          prop="platform_id"
                          size="small">
              <el-select v-model="addForm.platform_id"
                         size="small"
                         placeholder="请选择所属平台"
                         disabled>
                <el-option v-for="item in platformList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开店时间"
                          :rules="[{ required: true, message: '请选择开店时间' }]"
                          prop="open_date"
                          size="small">
              <el-date-picker v-model="addForm.open_date"
                              type="date"
                              placeholder="请选择开店时间"
                              value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd"
                              size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺网址"
                          size="small">
              <el-input clearable
                        placeholder="请输入店铺网址"
                        maxlength="100"
                        v-model="addForm.shop_url"
                        size="small">
                <template slot="prepend">
                  <el-select v-model="addForm.http_type"
                             size="mini"
                             filterable>
                    <el-option v-for="item in httpList"
                               :key="item"
                               :label="item"
                               :value="item"></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺邮箱"
                          size="small">
              <el-input clearable
                        placeholder="请输入店铺邮箱"
                        maxlength="100"
                        v-model="addForm.shop_email"
                        size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="save"
                 :loading='loading'>保存并去授权</el-button>
      <el-button size="small"
                 @click="addVisible = false">关闭</el-button>
    </span>
    <auth :authVisible.sync="authVisible"
          :shopId.sync="shopId"
          :authKeyList="authKeyList"></auth>
  </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import auth from "./auth";
export default {
    data() {
        return {
            addForm: {
                name: "",
                shop_abbr: "",
                platform_id: "",
                open_date: "",
                shop_email: "",
                shop_url: "",
                status: 1,
                http_type: "http://",
            },
            platformList: [],
            httpList: ["http://", "https://"],
            authKeyList: [],
            authForm: {},
            shopId: "",
            authVisible: false,
            loading: false,
        };
    },
    components: {
        auth: auth,
    },
    methods: {
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            this.loading = true;
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                    this.loading = false;
                }
            });
        },
        platformChange() {
            if (this.platform_id == 3) {
                this.authKeyList = [
                    { key: "appid", name: "AppId" },
                    { key: "secret", name: "Secret" },
                    { key: "shopname", name: "Shop Name" },
                ];
            } else if (this.platform_id == 4) {
                this.authKeyList = [
                    { key: "AppKey", name: "AppKey" },
                    { key: "AppSecret", name: "AppSecret" },
                    { key: "Token", name: "Token" },
                    { key: "ShopURL", name: "Shop URL" },
                ];
            } else {
                this.authKeyList = [];
            }
        },
        closeDialog() {
            this.addForm = {
                name: "",
                shop_abbr: "",
                platform_id: "",
                open_date: "",
                shop_email: "",
                shop_url: "",
                status: 1,
                http_type: "http://",
            };
            this.authKeyList = [];
            this.authForm = {};
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.loading = false;
            this.$emit("update:addVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.loading = true;
            this.platformChange();
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi.shop({ ...this.addForm }, "post").then((res) => {
                        if (res) {
                            this.shopId = res.data.id;
                            this.authVisible = true;
                            this.loading = false;
                        } else {
                            this.loading = false;
                        }
                    });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        platform_id: Number,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.platformSelect();
                    this.addForm.platform_id = this.platform_id;
                    this.addForm.track_id = this.userInfo.id
                        ? this.userInfo.id
                        : "";
                }
            },
            immediate: false,
            deep: true,
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.login.userInfo;
        },
    },
};
</script>
<style lang="scss">
.addstore {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
        .el-input-group__prepend {
            padding: 0;
            width: 100px;
            color: #666;
            text-align: center;
        }
    }
}
</style>
